// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__tV9A_","clinicsSelect":"TableHeading_clinicsSelect__1FKN1"};